// extracted by mini-css-extract-plugin
export default {"githubGraph":"githubContainer_githubGraph__TWpev","githubNotAvailable":"githubContainer_githubNotAvailable__3QegR","githubWrapper":"githubContainer_githubWrapper__i6QlC"};